import React, { useGlobal } from 'reactn'
import {
  SimpleGrid,
  Box,
  Container,
  Divider,
} from '@chakra-ui/react'
import { formatPrice } from '../../utils/format-price'
import { Dots } from './dotsAnimation'

const ShoppingCartTotals = ({ globalState }) => {
  const { store } = globalState
  const { countryChange } = store
  const { ts, calculating } = store

  return (
    <Box id="CartTotals">
      <Divider marginBottom={2} />
      <SimpleGrid columns={2}>
        {/* <Box /> */}
        <Container ml={0} mt={0} p={0} fontSize={14}>SHIPPING</Container>
        <Box pr={4} mt={0} fontSize={14} textAlign={'right'}>
          {formatPrice(countryChange || calculating ? null : ts.shipping_price)}
        </Box>
      </SimpleGrid>
      {ts.discount_price && ts.pc !== false &&
        <SimpleGrid columns={2}>
          <Container ml={0} mt={0} p={0} fontSize={14}>DISCOUNT</Container>
          <Box pr={4} mt={0} fontSize={14} textAlign={'right'}>
            {calculating ? null : formatPrice(ts.discount_price)}
          </Box>
        </SimpleGrid>
      }
      <SimpleGrid columns={2}>
        {/* <Box /> */}
        <Container ml={0} mt={0} p={0} fontSize={14}>TOTAL</Container>
        <Box pr={4} mt={0} fontSize={14} textAlign={'right'}>
          {/* {formattedNumber(cartTotal.totalPrice + shipping.value + packaging.value - discount.value)} */}
          {calculating  ? (
            <Box display="inline-block" transform="scale(0.7)" transformOrigin="right center">
              <Dots backgroundColor="#666" />
            </Box>
          ) : (
            formatPrice(ts.total_price)
          )}
        </Box>
      </SimpleGrid>
    </Box>
  )
}

export default ShoppingCartTotals